exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.feedback {\n  background: #fff;\n  width: 100%;\n  border-radius: 10px;\n  margin: 30px auto;\n}\n\n.feedback .form {\n  margin-top: 10px;\n}\n/* .feedback .form textarea {\n  min-height: 150px;\n  resize: none;\n} */\n.feedback .form input, .feedback .form textarea {\n  border-radius: 3px;\n  box-shadow: none;\n  border: 1px solid #e6e6e6;\n}\n\n.feed__image img{\n  width: 100%;\n  height: auto;\n  \n}\n.feed__image{\n  text-align: center;\n}\n\n#feedbackTab .active {\n  color:#1899ff !important;\n}", ""]);

// exports
